import { createContext } from 'react'

export interface SectionNavigationContextType {
  isVideoBlock: boolean
  isMondovino: boolean
}

const SectionNavigationContext = createContext<SectionNavigationContextType>({
  isVideoBlock: false,
  isMondovino: false,
})

const exports = { SectionNavigationContext }

export default exports
